import { render, staticRenderFns } from "./InfoQuestionMark.vue?vue&type=template&id=ac3c8240&scoped=true&"
import script from "./InfoQuestionMark.vue?vue&type=script&lang=js&"
export * from "./InfoQuestionMark.vue?vue&type=script&lang=js&"
import style0 from "./InfoQuestionMark.vue?vue&type=style&index=0&id=ac3c8240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3c8240",
  null
  
)

export default component.exports